export default class WidgetLanguageDetailModel {
	public language: string;
	public value: string;

	public constructor() {
		this.language = "";
		this.value = "";
	}
}
